import { render, staticRenderFns } from "./mainfun.vue?vue&type=template&id=3fd09082&scoped=true&"
import script from "./mainfun.vue?vue&type=script&lang=js&"
export * from "./mainfun.vue?vue&type=script&lang=js&"
import style0 from "./mainfun.vue?vue&type=style&index=0&id=3fd09082&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fd09082",
  null
  
)

export default component.exports